export const spaceConstants = {
    GET_REQUEST: 'SPACE_GET_REQUEST',
    GET_SUCCESS: 'SPACE_GET_SUCCESS',
    GET_FAILURE: 'SPACE_GET_FAILURE',
    GET_FAILURE_DONE: 'SPACE_GET_FAILURE_DONE'
}